<template>
  <div class="visaDetail">
    <ld-header>{{ visaSearchInfo.country }}</ld-header>

    <mescroll-vue
      class="wrapper"
      ref="mescroll"
      :down="down"
    >
      <DetailPanel
        class="round-sm mt5"
        :detail="visaSearchInfo.VisaDetail"
      />

      <div class="bg-white round-sm mt5">
        <van-cell
          title="所需信息"
          :border="false"
        />

        <van-cell-group>
          <van-field
            v-for="(personType, i) in visaSearchInfo.VisaDetail.visaDataPersonTypeBeans"
            :key="personType.crowdType"
            :label="personType.crowdTypeName"
            is-link
            :readonly="true"
            :placeholder="`需要${personType.contentBeans.length}项`"
            input-align="right"
            @click="materialOpen(i)"
          />
        </van-cell-group>
      </div>

      <div
        v-if="visaSearchInfo.VisaDetail.visaData1"
        class="pad8 bg-white round-sm mt5"
      >
        <h3>注意事项</h3>
        <pre
          class="pre-wrap gray"
          style="overflow: auto;"
          v-html="visaSearchInfo.VisaDetail.visaData1"
        />
      </div>

      <div
        v-if="associationsList.length > 0"
        class="pad8 bg-white round-sm mt5"
      >
        <h3>
          下载资料
        </h3>
        <div
          class="materials-item van-hairline--bottom"
          v-for="(association, i) in associationsList"
          :key="association.associationId"
          @click="download(association.associationPath)"
        >
          <a
            href="javascript:(0);"
            class="main-color pad8"
          >
            {{ i + 1 }}、{{ association.associationTitle }}
          </a>
        </div>
      </div>
    </mescroll-vue>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
      >
        <van-col
          span="12"
          :offset="1"
        >
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ visaSearchInfo.VisaDetail.salePrice }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}1人</span>
        </van-col>
        <van-col
          :offset="2"
          span="8"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.native="book"
          >
            预订
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 资料详情 -->
    <Material
      :p-active="materialActive"
      :title="`${visaSearchInfo.country}-${visaSearchInfo.VisaDetail.visaTypeName}`"
      :detail="visaSearchInfo.VisaDetail.visaDataPersonTypeBeans"
      :visibility.sync="materialShow"
    />
  </div>
</template>

<script>
import { Cell, CellGroup, Field } from 'vant'
import { mapGetters } from 'vuex'

import Material from './Material'
import DetailPanel from './DetailPanel'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'

import VisaBookInterator from 'Domain/use-cases/visa-book-interactor'

export default {
  name: 'VisaDetail',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    ldButton, ldTabbar, Material, DetailPanel,
    MescrollVue: () => import('mescroll.js/mescroll.vue')
  },
  data () {
    return {
      down:{ use: false },
      materialActive: 0,
      associationsList: [],
      materialShow: false
    }
  },
  async created () {
    const { VisaDetail, Associations } = await VisaBookInterator.getVisaDetail({
      ...this.visaSearchInfo,
      ...this.visaSearchInfo.VisaDetail
    })
    this.visaSearchInfo.VisaDetail = VisaDetail
    this.associationsList = Associations
  },
  methods: {
    download (url) {
      this.$LdDownload({ sendScene: 4, url })
    },
    materialOpen(i) {
      this.materialShow = true 
      this.materialActive = i
    },
    book() {
      this.$router.push('/visa/edit')
    }
  },
  computed: {
    ...mapGetters({
      visaSearchInfo: 'visa/visaSearchInfo',
      travelerList: 'visa/travelerList'
    })
  }
}
</script>

<style lang="less">
.visaDetail {
  .wrapper {
    padding: 0 8px;
    height: calc(100vh - 100px);
  }

  h3 {
    margin: 0;
    margin-bottom: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .materials-item {
    padding: 5px 0;
  }
}
</style>
